<template>
	<div>
		<div style="width:1200px;margin: 0 auto;">
			<div class="dingdan">
				<el-breadcrumb separator-class="el-icon-arrow-right">
				  <el-breadcrumb-item>个人中心</el-breadcrumb-item>
				  <el-breadcrumb-item :to="{ path: '/serviceHome/MyReview' }">我的评审</el-breadcrumb-item>
				  <el-breadcrumb-item>评审详情</el-breadcrumb-item>
				</el-breadcrumb>
				<div class="fh_button">
					<i class="el-icon-arrow-left"></i>
					<p>返回</p>
				</div>
			</div>
			<div class="ReviewDatails">
				<h3 class="ReviewH3">发起评审的阶段</h3>
				<div class="Reviewdiv">需求方在<span v-if="datails.review.stage==1">承认图 </span> <span v-else>生产图</span>阶段发起了评审，请评审员仔细查看双方信息进行评审</div>
			</div>
			<div class="ReviewDatails">
				<h3 class="ReviewH3">需求详情</h3>
				<div class="Reviewdiv1"> 
				     {{datails.order.demand.description}}
				</div>
				<div class="Reviewdiv2">
					<div class="Reviewdiv2_1">
						<h4>需求详情</h4>
						<div>
							<img :src="i" mode="" v-for="(i,index) in datails.order.demand.file" alt="" srcset="" />
							<figure v-if="datails.order.demand.file.length==0" style="width:100%;text-align: center;">
								<img src="@/assets/kong.png" alt="" srcset="" />
							</figure>
						</div>
					</div>
					<div  class="Reviewdiv2_1">
						<h4>交付流程</h4>
						<div>
							<img :src="datails.order.demand.confirm_image" alt="" srcset="" />
							<img :src="datails.order.demand.produce_image" alt="" srcset="" />
						</div>
					</div>
				</div>
			</div>
			<div class="ReviewDatails">
				<h3 class="ReviewH3">验收相关信息</h3>
				<div class="ReviewView">
					<p>服务方提交内容 <span>（根据中标时间进行计算，完成周期剩余时间 每个阶段仅支持服务方提交五次附件）</span></p>
				</div>
				<ul class="ReviewUl">
					<li>中标时间：<span>{{datails.order.create_time}}</span></li>
					<li>服务方交付周期：<span>{{datails.order.period_format}}</span></li>
					<li>一阶段承认图：<span>{{datails.review.orderStage.period_format}}</span></li>
					<li>二阶段生产图：<span>{{datails.review.orderStage.period_format}}</span></li>
				</ul>
				<h4 style="line-height:50px;">服务方提供的验收相关材料</h4>
				<div class="jfimglist">
					<div v-for="(i,index) in datails.order.file"  :key="i" class="jfimg">
						<div class="jfimgbox">
							<img :src="i.file" alt="" srcset="" />
							<div>
								<span v-if="i.stage==1">{{index+1}},承认图</span>
								<span v-if="i.stage==2">{{index+1}},生产图</span>
								<p>{{i.create_time}}</p>
							</div>
						</div>
						<span>查看</span>
					</div>
				</div>
			</div>
			<div class="ReviewDatails2">
			   <div class="Reviewlist">
				   <div class="Reviewser">
					   <h4>需求方原因说明</h4> <span>{{datails.review.pay_time*1000 | dateFormat}}</span>
				   </div>
				   <div class="Reviewser1">
					   <h4>原因说明</h4>
					   <p>{{datails.review.demand_content}}</p>
					    <h4>相关问题附件</h4>
						<div style="display:flex;">
							<img 
								:src="i" 
								style="width:80px;height:80px;border-radius:8px;margin-right:10px;"
								mode="" 
								:key="index" 
								v-for="(i,index) in datails.review.demand_image"  
								class="demand_image" 
								/>
						</div>
				   </div>
			   </div>
			   <div class="Reviewlist">
				   <div class="Reviewser">
				   		<h4>服务方原因说明</h4> <span>{{datails.review.defense_time*1000 | dateFormat}}</span>
				   </div>
				 <!--  <el-empty image="./assets/kong.png" description="过期未填写原因"></el-empty> -->
				  <div class="Reviewser1">
					   <h4>原因说明</h4>
					   <p>{{datails.review.service_content}}</p>
						<h4>相关问题附件</h4>
						<div style="display:flex;">
							<img 
								:src="i" 
								style="width:80px;height:80px;border-radius:8px;margin-right:10px;"
								mode="" 
								:key="index" 
								v-for="(i,index) in datails.review.demand_image"  
								class="demand_image" 
								/>
						</div>
				   </div>
				   
			   </div>
			</div>
			<div class="ReviewFooter"  v-if="datails.status==0">
				<p class="ReviewFooterP">提示：支持方为败方或者未评审将无法获得评审金</p>
				<h4 class="ReviewFooterH4">过期未评审</h4>
				<div>立即评审</div>
			</div>
			<div class="ReviewDatails" v-if="datails.status==1" style="margin-top:20px;">
				<h3 class="ReviewH3">我的评审</h3>
				<div class="ReviewPS">
					<h4>我所选的支持方</h4>
					<div class="ReviewZCF" v-if="datails.support==2">
						<img src="@/assets/fabu.png" alt="" srcset="" />
						<span>需求方</span>
						<span v-if="datails.review.win==1">(胜方)</span>
						<span v-if="datails.review.win==2">(败方)</span>
						<span v-if="datails.review.win==0">(暂无评审结果)</span>
					</div>
					<div class="ReviewZCF" v-if="datails.support==1">
						<img src="@/assets/fabu.png" alt="" srcset="" />
						<span>服务方</span>
						<span v-if="datails.review.win==1">(胜方)</span>
						<span v-if="datails.review.win==2">(败方)</span>
						<span v-if="datails.review.win==0">(暂无评审结果)</span>
					</div>
					<h4>我的评审意见</h4>
					<div class="ReviewPSYJ">
						{{datails.content}}
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		OrderReviewUserDetail
	} from "@/api/api.js";
	export default {
	  name: 'HelloWorld',
	 //  components:{
		// rightsidebarImg  
	 //  },
	  data() {
	    return {
		   curNow:0 , //0为需求方信息 1为服务方信息
		   oruId:"",
		   datails:""
	    }
	  },
	  computed: {
		oru_id() {
		   return this.$route.query.oru_id || ''
		}
	  },
	  mounted() {
	     this.getdatails()
	  },
	  methods: {
		  getdatails(){
		  	OrderReviewUserDetail(this.oru_id,{
		  		
		  	}).then(res=>{
		  		this.datails=res.data.data
		  	})
		  },
	  },
	}
</script>

<style scoped>
	.dingdan{
		width:1200px;
		margin:0 auto;
		padding:36px 0px;
		box-sizing: border-box;
		display:flex;
		justify-content:space-between;
		align-items: center;
	}
	.fh_button{
		width: 58px;
		height: 24px;
		line-height:24px;
		background: #1E3A8A;
		border-radius: 4px ;
		font-weight: 500;
		font-size: 12px;
		color: #FFFFFF;
		display:flex;
		align-items:center;
		justify-content:center;
	}
	.fh_button i{
		margin-right:5px;
	}
	.ReviewDatails{
		width:100%;
		background-color:#fff;
		border-radius:12px;
		padding:20px;
		box-sizing: border-box;
		margin-bottom:24px;
	}
	.ReviewH3{
		font-weight: bold;
		font-size: 16px;
		color: #333333;
	}
	.Reviewdiv{
		width:100%;
		background: rgba(66,151,255,0.1);
		border-radius: 8px 8px 8px 8px;
		padding:20px;
		box-sizing: border-box;
		font-weight: 500;
		font-size: 16px;
		color: rgba(255,0,0,0.8);
		text-align: center;
		margin-top:18px;
	}
	.Reviewdiv1{
		font-weight: 400;
		font-size: 14px;
		color: #333333;
		margin-top:12px;
	}
	.Reviewdiv2{
		width:100%;
		display:flex;
		justify-content:space-between;
		align-items: center;
		margin-top:24px;
	}
	.Reviewdiv2_1{
		width:50%;
		padding-right:10px;
		box-sizing: border-box;
	}
	.Reviewdiv2_1 h4{
		font-weight: bold;
		font-size: 14px;
		color: #333333;
	}
	.Reviewdiv2_1 div{
		width:100%;
		display:flex;
		align-items: center;
		margin-top:12px;
	}
	.Reviewdiv2_1 img{
		width:72px;
		height:72px;
		border-radius: 8px 8px 8px 8px;
		margin-right:16px;
	}
	.ReviewView{
		width:100%;
		margin-top:18px;
	}
	.ReviewView p{
		font-weight: bold;
		font-size: 14px;
		color: #333333;
	}
	.ReviewView p>span{
		font-weight: 400;
		font-size: 14px;
		color: rgba(255,0,0,0.8);
	}
	.ReviewUl{
		width:100%;
		display:flex;
		justify-content:space-between;
		align-items: center;
		margin-top:12px;
		font-weight: 400;
		font-size: 14px;
		color: #666666;
	}
	.ReviewUl span{
		font-weight: bold;
		font-size: 14px;
		color: #333333;
	}
	.jfimglist{
		width:100%;
		display: flex;
		flex-wrap:wrap;
	}
	.jfimg{
		width: 374px;
		height: 66px;
		background: rgba(30,58,138,0.15);
		border-radius: 12px 12px 12px 12px;
		display:flex;
		justify-content:space-between;
		align-items: center;
		margin-right:12px;
		margin-bottom:12px;
		padding:12px;
		box-sizing: border-box;
	}
	.jfimglist>div:nth-child(3n){
		margin-right:none;
	}
	.jfimgbox{
		display:flex;
		align-items:center;
	}
	.jfimgbox img{
		width:42px;
		height:42px;
		border-radius:6px;
		margin-right:5px;
	}
	.jfimgbox span{
		font-weight: 500;
		font-size: 14px;
		color: #1E3A8A;
	}
	.jfimgbox p{
		font-weight: 400;
		font-size: 12px;
		color: rgba(30,58,138,0.6);
	}
	.jfimg>span{
		font-weight: 400;
		font-size: 14px;
		color: #4297FF;
	}
	.Reviewlist{
		width: 588px;
		background: #FFFFFF;
		box-shadow: 0px 4px 4px 0px rgba(0,0,0,0.05);
		border-radius: 12px 12px 12px 12px;
		padding:12px;
		box-sizing: border-box;
	}
	.ReviewDatails2{
		width:100%;
		display:flex;
		justify-content:space-between;
	}
	.Reviewser{
		width:100%;
		display:flex;
		justify-content:space-between; 
		align-items: center;
	}
	.Reviewser span{
		font-weight: 400;
		font-size: 12px;
		color: #666666;
	}
	.Reviewser1>h4{
		font-weight: bold;
		font-size: 14px;
		color: #333333;
		line-height:30px;
	}
	.Reviewser1>p{
		font-weight: 400;
		font-size: 14px;
		color: #333333;
		margin-bottom:12px;
	}
	.ReviewFooter{
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		flex-wrap:wrap;
		padding:30px 0px;
	}
	.ReviewFooterP{
		font-weight: 400;
		font-size: 14px;
		color: #FF0000;
		margin-bottom:10px;
	}
	.ReviewFooterH4{
		font-weight: 500;
		font-size: 16px;
		color: #999999;
	}
	.ReviewPS h4{
		font-weight: bold;
		font-size: 14px;
		color: #333333;
		line-height:40px;
	}
	.ReviewZCF{
		display:flex;
		align-items:center;
	}
	.ReviewZCF img{
		width:24px;
		height:24px;
		margin-right:5px;
	}
	.ReviewZCF span{
		font-weight: 500;
		font-size: 14px;
		color: #333333;
	}
	.ReviewPSYJ{
		font-weight: 400;
		font-size: 14px;
		color: #333333;
	}
</style>